export default "__VITE_ASSET__94rNrllZ__"